import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import useAuthRequest from '../../../../services/requests.service';
import OffersTable from './OffersTable';
import CreateOfferModal from '../../../Company/Offer/CreateOfferModal';

const OffersAll = ({ setIsLoading }) => {
  const request = useAuthRequest();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentDeal, setCurrentDeal] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [response, setResponse] = useState(null);


  // React Query hook pour récupérer les deals
  const {
    data: deals,
    isLoading,
    error,
    refetch
  } = useQuery({
    queryKey: ['dealsAll', currentPage, pageSize],
    queryFn: async () => {
      const res = await request.getDataAPI(`dealsAll?n=${pageSize}&page=${currentPage}`);
      return res;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 2,
    onError: (error) => {
      console.error('Failed to fetch deals', error);
    }
  });

  // Loading state avec design cohérent
  if (isLoading) {
    return (
      <div className="flex justify-center items-center min-h-[400px]">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-royalblue-500 mx-auto"></div>
          <p className="mt-4 text-gray-600 dark:text-gray-400 text-sm sm:text-base">
            Chargement des offres...
          </p>
        </div>
      </div>
    );
  }

  // Error state avec retry
  if (error) {
    return (
      <div className="text-center p-8">
        <h2 className="text-lg sm:text-xl font-semibold text-red-600 mb-4">
          Erreur lors du chargement des offres
        </h2>
        <p className="text-gray-600 dark:text-gray-400 mb-4">
          {error.message || 'Une erreur est survenue'}
        </p>
        <button 
          onClick={() => refetch()}
          className="px-4 py-2 bg-royalblue-500 text-white rounded-lg hover:bg-royalblue-600 transition-colors"
        >
          Réessayer
        </button>
      </div>
    );
  }

  return (
    <div className='overflow-x-auto'>

            
      {deals?.deals && (
        <OffersTable 
          setCurrentDeal={setCurrentDeal} 
          datas={deals} 
          deals={deals} 
          setDeals={() => {}} // Plus nécessaire avec React Query
          setIsModalOpen={setIsModalOpen}  
          currentPage={currentPage} 
          setPage={() => {}} // Plus nécessaire avec React Query
          pageSize={pageSize}
          total={deals?.total}
          onPageChange={(page, size) => {
            setCurrentPage(page);
            setPageSize(size);
          }} 
        />
      )}

      <CreateOfferModal 
        isAdmin={true} 
        setCurrentDeal={setCurrentDeal} 
        currentDeal={currentDeal} 
        deals={deals} 
        setDeals={() => {}} // Plus nécessaire avec React Query
        page={null} // Plus nécessaire avec React Query
        setIsLoading={setIsLoading} 
        setIsModalOpen={setIsModalOpen} 
        isModalOpen={isModalOpen} 
        setResponse={setResponse}
      />
    </div>
  );
};

export default OffersAll;